import { render } from "./LeaveReason.vue?vue&type=template&id=20acf54a&scoped=true&ts=true"
import script from "./LeaveReason.vue?vue&type=script&lang=ts"
export * from "./LeaveReason.vue?vue&type=script&lang=ts"

import "./LeaveReason.vue?vue&type=style&index=0&id=20acf54a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20acf54a"]])

export default __exports__